/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Comparison operator
 */
export type FilterItemDtoOperator = typeof FilterItemDtoOperator[keyof typeof FilterItemDtoOperator];


export const FilterItemDtoOperator = {
  equals: 'equals',
  not: 'not',
  after: 'after',
  before: 'before',
  onOrAfter: 'onOrAfter',
  onOrBefore: 'onOrBefore',
  contains: 'contains',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  isEmpty: 'isEmpty',
  isNotEmpty: 'isNotEmpty',
  isAnyOf: 'isAnyOf',
} as const;
